import ItemFormularioCampo from "./ItemFormularioCampo";

export default class ItemFormulario {
    Id: number;
    Descripcion: string;
    Version: number;
    EstructuraFormulario: string;
    Columnas: ItemFormularioCampo[];

    constructor() {
        this.Id = 0;
        this.Descripcion = "";
        this.Version = 0;
        this.EstructuraFormulario = "";
        this.Columnas = [];
    };
};
